import { useCallback, useEffect, useState } from 'react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

// status: 'loading' | 'available' | 'soldout' | 'unknown' (conteggio non disponibile: acquistabile, senza badge)
export const useFounderSpots = (enabled = true) => {
  const [spots, setSpots] = useState({ status: 'loading', spotsLeft: null });

  useEffect(() => {
    if (!enabled) return undefined;
    let cancelled = false;
    setSpots({ status: 'loading', spotsLeft: null });
    fetch(`${API_URL}/api/founder-spots`)
      .then((res) => (res.ok ? res.json() : Promise.reject(new Error(`HTTP ${res.status}`))))
      .then((data) => {
        if (!cancelled) setSpots({ status: data.spots_left > 0 ? 'available' : 'soldout', spotsLeft: data.spots_left });
      })
      .catch(() => {
        if (!cancelled) setSpots({ status: 'unknown', spotsLeft: null });
      });
    return () => { cancelled = true; };
  }, [enabled]);

  const markSoldOut = useCallback(() => setSpots({ status: 'soldout', spotsLeft: 0 }), []);

  return { ...spots, soldOut: spots.status === 'soldout', markSoldOut };
};

const founderBadge = ({ status, spotsLeft }) => {
  if (status === 'soldout') return 'Esaurito';
  if (status !== 'available') return null;
  return spotsLeft === 1 ? 'Solo 1 posto rimasto' : `Solo ${spotsLeft} posti rimasti`;
};

export const withFounderStatus = (plan, founder) => (
  plan.id !== 'fondatori' ? plan : {
    ...plan,
    badge: founderBadge(founder),
    urgency: founder.status === 'available',
    soldOut: founder.soldOut
  }
);
